module.exports = __webpack_public_path__ + "static/media/funnel-fill-icon.6df4c143.svg";